var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWorks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "14-tasks") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_14-tasks",
    "data-name": "14-tasks"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31,48H5a5.006,5.006,0,0,1-5-5V9a1,1,0,0,1,.293-.707l8-8A1,1,0,0,1,9,0H31a5.006,5.006,0,0,1,5,5V27H34V5a3,3,0,0,0-3-3H9.414L2,9.414V43a3,3,0,0,0,3,3H31a3,3,0,0,0,3-3V41h2v2A5.006,5.006,0,0,1,31,48Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,10H5V8H7A1,1,0,0,0,8,7V1h2V7A3,3,0,0,1,7,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.769,41h0a1,1,0,0,1-.707-.293l-2.769-2.769a1,1,0,0,1,0-1.415l15.231-15.23a1,1,0,0,1,1.414,0l2.769,2.769a1,1,0,0,1,0,1.415L32.476,40.707A1,1,0,0,1,31.769,41Zm-1.355-3.77,1.355,1.356L45.586,24.769l-1.355-1.355Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,41H29a1,1,0,0,1-1-1V37h2v2h2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,9H30V7a1,1,0,0,0-1-1H27V4h2a3,3,0,0,1,3,3Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 4,
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,21H6a1,1,0,0,1-1-1V14a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,12,21ZM7,19h4V15H7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,31H6a1,1,0,0,1-1-1V24a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,12,31ZM7,29h4V25H7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,41H6a1,1,0,0,1-1-1V34a1,1,0,0,1,1-1h6a1,1,0,0,1,1,1v6A1,1,0,0,1,12,41ZM7,39h4V35H7Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 14,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 18,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 24,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 28,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 34,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 38,
    width: 11,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.757,
    y: 16,
    width: 8.485,
    height: 2,
    transform: "translate(-9.385 11.343) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.757,
    y: 26,
    width: 8.485,
    height: 2,
    transform: "translate(-16.456 14.272) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4.757,
    y: 36,
    width: 8.485,
    height: 2,
    transform: "translate(-23.527 17.201) rotate(-45)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorks);
export default __webpack_public_path__ + "static/media/works.7525adfc66c3afa006630fe4318c1f3c.svg";
export { ForwardRef as ReactComponent };